import { useCallback } from 'react';
import useMarketPagination from 'hooks/useMarketPagination';
import useRefreshWhenStale from 'hooks/useRefreshWhenStale';
import { DEFAULT_PAGE_NUMBER } from 'utils/constants';

const FIVE_MINUTES = 1000 * 60 * 5;
const STORAGE_KEY = 'loadTime';

/**
 * @returns
 * Automatically refreshes the market results if more than five minutes have passed since the last load time
 */
const useMarketAutoRefresh = (onRefresh: () => void) => {
  const { pageNumber, onResetPagination } = useMarketPagination();

  const handleStale = useCallback(() => {
    if (pageNumber === DEFAULT_PAGE_NUMBER) {
      onRefresh();
    } else {
      onResetPagination();
    }
  }, [onRefresh, pageNumber, onResetPagination]);

  return useRefreshWhenStale({ storageKey: STORAGE_KEY, maxAgeMs: FIVE_MINUTES, onStale: handleStale });
};

export default useMarketAutoRefresh;
